import type { SiteThemeConfig } from "@site-factory/config";
import type { ThemeName } from "./themes";
import { getTheme } from "./themes";

/**
 * Theme selection - can be a theme name, theme with overrides, or inline config
 */
export type ThemeSelection =
  | ThemeName // "default" | "polar-pop"
  | { base: ThemeName; overrides?: Partial<SiteThemeConfig> } // { base: "polar-pop", overrides: { primary: "#..." } }
  | SiteThemeConfig; // Legacy inline format

/**
 * Resolve a theme selection to a complete SiteThemeConfig
 */
export function resolveTheme(selection: ThemeSelection): SiteThemeConfig {
  // If it's a string, get from registry
  if (typeof selection === "string") {
    return getTheme(selection);
  }

  // If it has a 'base' property, merge with overrides
  if (selection && typeof selection === "object" && "base" in selection) {
    const baseTheme = getTheme(selection.base);
    const { base, overrides, ...rest } = selection as any;
    return {
      ...baseTheme,
      ...(overrides || {}),
      ...rest,
    };
  }

  // Otherwise, it's already a complete SiteThemeConfig (legacy format)
  return selection as SiteThemeConfig;
}
